import React, { Component } from "react";
import SpotifyEmbed from "../components/SpotifyEmbed";
import Book from "../components/Book";
import { spotifyIds, books } from "../constants/about-data";
import "../styles/about.css";

class About extends Component {
  render() {
    return (
      <main style={{ ...this.props.style }}>
        <div className="sub-section about">
          <header>
            <div className="profile-image">
              <img
                alt="Ben Bright portrait"
                src="/images/me.jpg"
                width="200"
                height="200"
              />
            </div>
            <h1>
              I’m Ben Bright. I tend patches of internet, haunt music venues,
              and hike when it’s unreasonably hot
            </h1>
          </header>
          <article>
            <p>
              I’m a full-stack engineer based in Birmingham, Alabama. I’ve been
              building internet things since 2010 when I discovered JavaScript’s
              harrowing DOM powers. Since then, I’ve worked with startups, large
              companies, non-profits and everything in between to build
              thoughtful web and mobile experiences. I fuss over the details of
              UX, flexible data models and maintainable, well-documented code.
            </p>
            <p>
              When I’m not shifting bits, you can find me on hiking trails,
              traveling, reading in the park, or catching a random show at my
              favorite music venue. If you want a fun story, ask me about the
              time I almost died an embarrassing death in Norway.
            </p>
          </article>
          <article>
            <h1>Some books I’ve read recently:</h1>
            <h2>
              Images from{" "}
              <a href="https://openlibrary.org/dev/docs/api/covers">
                Open Library
              </a>
              . Some descriptions from{" "}
              <a href="https://wikipedia.org">Wikipedia</a>
            </h2>
            <ul>
              {books.map(book => (
                <li key={book.title}>
                  <Book {...book} />
                </li>
              ))}
            </ul>
          </article>
          <article className="music">
            <h1>
              Music I’ve been listening to recently (a very incomplete list):
            </h1>
            <ul>
              {spotifyIds.map(id => (
                <li key={id}>
                  <SpotifyEmbed id={id} />
                </li>
              ))}
            </ul>
          </article>
        </div>
      </main>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/pages/About.js